import yaml from 'js-yaml';
export const mystdemoDirective = {
    name: 'myst',
    options: {
        numbering: {
            type: String,
        },
    },
    body: {
        type: String,
        required: true,
    },
    run(data) {
        var _a;
        let numbering;
        if ((_a = data.options) === null || _a === void 0 ? void 0 : _a.numbering) {
            try {
                numbering = yaml.load(data.options.numbering);
            }
            catch (err) {
                //pass
            }
        }
        return [
            {
                type: 'myst',
                numbering,
                value: data.body,
            },
        ];
    },
};
